module.exports = __webpack_public_path__ + "static/media/Motor  Shafts.69b221c9.webp";